import cfg from 'cfg';
import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
import auth from '../auth';
import { toIdArray } from 'dash-front/helpers';
import {
    FILTER_WIDGETS_TEXT,
    GET_PACK_WIDGETS,
    RESET_PACK_WIDGETS,
    POST_PACK_WIDGET,
    DELETE_PACK_WIDGET
} from './constants';

const sortByName = arr =>
    arr.sort((packA, packB) => {
        const nameA = packA.name.toLowerCase();
        const nameB = packB.name.toLowerCase();

        if (nameA > nameB) return 1;
        if (nameA < nameB) return -1;

        return 0;
    });

export const fetchWidgets = () =>
    requestAsync({
        url: `${cfg.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}`,
        update: {
            widgets: UPDATE_DEFAULT.MERGE
        },
        transform: ({ widgets }) => ({
            widgets: widgets.reduce((acc, el) => {
                acc[el._id] = el;

                return acc;
            }, {})
        }),
        list: ({ widgets }) => ({
            widgets: () => toIdArray(sortByName(widgets))
        }),
        queryKey: 'GET:widgets',
        options: {
            method: httpMethods.GET
        }
    });

export const fetchPacks = () =>
    requestAsync({
        url: `${cfg.dash.api.host}/api/admin/packs?access_token=${auth.getAccessToken()}`,
        update: {
            packs: UPDATE_DEFAULT.MERGE
        },
        transform: body => ({
            packs: body.reduce((acc, el) => {
                acc[el._id] = el;

                return acc;
            }, {})
        }),
        list: body => ({
            packs: () => toIdArray(body)
        }),
        queryKey: 'GET:packs',
        options: {
            method: httpMethods.GET
        }
    });

export const createPack = pack =>
    requestAsync({
        url: `${cfg.dash.api.host}/api/admin/packs?access_token=${auth.getAccessToken()}`,
        body: pack,
        update: {
            packs: UPDATE_DEFAULT.MERGE
        },
        transform: body => ({
            packs: { [body._id]: body }
        }),
        list: body => ({
            packs: prevList => prevList.concat(body._id)
        }),
        queryKey: 'POST:packs',
        options: {
            method: httpMethods.POST,
            headers: {
                'Content-Type': 'application/json'
            }
        }
    });

export const updatePack = (packId, packWidgets) =>
    requestAsync({
        url: `${cfg.dash.api.host}/api/admin/packs/${packId}?access_token=${auth.getAccessToken()}`,
        body: packWidgets,
        update: {
            packs: UPDATE_DEFAULT.MERGE
        },
        transform: body => ({
            packs: { [body._id]: body }
        }),
        list: () => ({}),
        queryKey: 'PUT:packs',
        options: {
            method: httpMethods.PUT
        }
    });

export const deletePack = packId =>
    requestAsync({
        url: `${cfg.dash.api.host}/api/admin/packs/?access_token=${auth.getAccessToken()}`,
        body: { id: packId },
        update: {
            packs: UPDATE_DEFAULT.MERGE
        },
        transform: () => {
            return {
                packs: {}
            };
        },
        list: body => ({
            packs: prevList => prevList.filter(id => id !== body._id)
        }),
        queryKey: 'DELETE:packs',
        options: {
            method: httpMethods.DELETE
        }
    });

export function filterWidgetsText(text) {
    return {
        type: FILTER_WIDGETS_TEXT,
        payload: { text }
    };
}

export function getPackWidgets(packId, widgets) {
    return {
        type: GET_PACK_WIDGETS,
        payload: { packId, widgets }
    };
}

export function resetPackWidgets() {
    return {
        type: RESET_PACK_WIDGETS
    };
}

export function postPackWidget(widgetId) {
    return {
        type: POST_PACK_WIDGET,
        payload: { widgetId }
    };
}

export function deletePackWidget(widgetId) {
    return {
        type: DELETE_PACK_WIDGET,
        payload: { widgetId }
    };
}



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/actions.js
 **/